import toPx from "unit-to-px";
import { getImageDimensions } from "../getImageDimensions";
import { addPage } from "./addPage";
import obsDoc from "./obsDoc";
import { resizeImage } from "../resizeImage";
import { loadImage } from "../loadImage";

export async function addPics(doc, pics, cursorY) {
  const pageHeight = doc.internal.pageSize.height - 1; // Get page height minus some
  const pageWidth = doc.internal.pageSize.width; // Get page width
  //Observation Pics
  const pxPerMM = toPx("in");
  var i = 0;
  var evenImageHeightInMM = 0;
  var evenCaptions = [];
  var oddImageHeightInMM = 0;
  var oddCaptions = [];
  for (i = 0; i < pics.length; i++) {
    var isEven = i % 2 === 0;
    //Evens (first col)
    if (isEven) {
      var evenIm = await loadImage(pics[i].file);
      var evenP = resizeImage(evenIm);
      var evenPicDem = await getImageDimensions(
        evenP
        // "data:image/png;base64," + pics[i].pic
      );
      evenImageHeightInMM = evenPicDem.height / pxPerMM;
      console.log(`even width: ${evenPicDem.width}`);

      // Split the text into lines
      evenCaptions = doc.splitTextToSize(pics[i].comment, pageWidth / 2 - 0.5);
    } else {
      //Odds (sec col)
      var oddIm = await loadImage(pics[i].file);
      var oddP = resizeImage(oddIm);
      var oddPicDem = await getImageDimensions(
        oddP
        // "data:image/png;base64," + pics[i].pic
      );
      oddImageHeightInMM = oddPicDem.height / pxPerMM;
      console.log(`odd width: ${oddPicDem.width}`);

      // Split the text into lines
      oddCaptions = doc.splitTextToSize(pics[i].comment, pageWidth / 2 - 0.5);
    }

    var maxPicHeight = Math.max(evenImageHeightInMM, oddImageHeightInMM);
    var maxPicCaptionHeight = Math.max(
      evenCaptions.length * obsDoc.lineSpacing,
      oddCaptions.length * obsDoc.lineSpacing
    );

    // double row of pics
    if (isEven === false) {
      if (cursorY + maxPicHeight + maxPicCaptionHeight > pageHeight) {
        //addPage
        cursorY = await addPage(doc, cursorY);
      }
      //add even photo
      doc.addImage(evenP, "JPEG", 0.5, cursorY);
      //add odd photo
      doc.addImage(oddP, "JPEG", pageWidth / 2, cursorY);

      //add even photo caption
      var capCursorY = cursorY + evenImageHeightInMM + obsDoc.lineSpacing;
      var x;
      for (x = 0; x < evenCaptions.length; x++) {
        doc.text(obsDoc.xPosition, capCursorY, evenCaptions[x]);
        capCursorY += obsDoc.lineSpacing;
      }

      //add odd photo caption
      var oddCapCursorY = cursorY + oddImageHeightInMM + obsDoc.lineSpacing;
      var y;
      for (y = 0; y < oddCaptions.length; y++) {
        doc.text(pageWidth / 2, oddCapCursorY, oddCaptions[y]);
        oddCapCursorY += obsDoc.lineSpacing;
      }
      // add spacing for photo and space below caption line.
      cursorY = cursorY + maxPicHeight + obsDoc.lineSpacing;
      // add spacing for caption line(s)
      cursorY +=
        Math.max(evenCaptions.length, oddCaptions.length) * obsDoc.lineSpacing;
      // skip 1 line after caption
      cursorY = cursorY + obsDoc.lineSpacing;
    } else if (pics.length - 1 === i) {
      // single row of pics
      if (cursorY + maxPicHeight + maxPicCaptionHeight > pageHeight) {
        //addPage
        cursorY = await addPage(doc, cursorY);
      }
      //add photo
      doc.addImage(evenP, "JPEG", 0.5, cursorY);
      // add spacing for photo and caption line.
      cursorY = cursorY + maxPicHeight + obsDoc.lineSpacing;

      //add even photo caption
      var z;
      for (z = 0; z < evenCaptions.length; z++) {
        doc.text(obsDoc.xPosition, cursorY, evenCaptions[z]);
        cursorY += obsDoc.lineSpacing;
      }

      // skip 1 line after caption
      cursorY = cursorY + obsDoc.lineSpacing;
    }
  }

  return cursorY;
}
